import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class KeywordService {
  private keywordSubject = new BehaviorSubject<string>('');
  keyword$: Observable<string> = this.keywordSubject.asObservable();

  updateKeyword(keyword: string) {
    this.keywordSubject.next(keyword);
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/keyword.service.ts